<div class="progress{{component?.data?.direction == 'v' ? ' progress-v' : null}}" role="progressbar"
    aria-label="Basic example" [attr.aria-valuenow]="component?.data?.progress ? component?.data?.progress : 0"
    [attr.aria-valuemin]="component?.data?.min ? component?.data?.min : 0"
    [attr.aria-valuemax]="component?.data?.max ? component?.data?.max : 0" (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="progress-bar"
        style="{{component?.data?.direction == 'v' ? 'height' : 'width'}}: {{component?.data?.progress ? component?.data?.progress/component?.data?.max * 100 : 0}}%">
    </div>
</div>